import React from 'react';
import { PageHero } from '../components/layout/PageHero';
import { DocumentCard } from '../components/procurement/DocumentCard';
import { SectionHeading } from '../components/ui/SectionHeading';
import { procurementDocuments } from '../data/procurement';
export function ProcurementManual() {
  const featuredDoc = procurementDocuments.find(doc => doc.featured);
  const otherDocs = procurementDocuments.filter(doc => !doc.featured);
  return <div data-id="element-789" data-mp="1r35uey9lbsg9">
      <PageHero title="Procurement Manual" subtitle="Comprehensive guidelines, policies, and procedures for AU procurement" breadcrumbs={[{
      label: 'Home',
      path: '/'
    }, {
      label: 'Procurement'
    }, {
      label: 'Manual'
    }]} data-id="element-790" data-mp="1r73dxl02ym0o" />

      <div className="max-w-7xl mx-auto px-4 py-12" data-id="element-791" data-mp="5sfibb229rcv">
        {featuredDoc && <div className="mb-12" data-id="element-792" data-mp="1r40hrpfiaf8">
            <SectionHeading title="Featured Document" subtitle="The complete guide to African Union procurement processes" data-id="element-793" data-mp="1rvk045r4hp5" />
            <div className="mt-8" data-id="element-794" data-mp="18pmllmt3o6lp">
              <DocumentCard title={featuredDoc.title} description={featuredDoc.description} version={featuredDoc.version} date={featuredDoc.date} documentUrl={featuredDoc.documentUrl} featured={true} index={0} data-id="element-795" data-mp="18ourkgf5igxj" />
            </div>
          </div>}

        <div data-id="element-796" data-mp="1rdhrkkih0g49">
          <SectionHeading title="Related Documents" subtitle="Additional guidelines and resources for suppliers and contractors" data-id="element-797" data-mp="1rd9g8x1zxiv6" />
          <div className="grid md:grid-cols-2 gap-6 mt-8" data-id="element-798" data-mp="21c7amgm3s6m3">
            {otherDocs.map((doc, index) => <DocumentCard key={doc.id} title={doc.title} description={doc.description} version={doc.version} date={doc.date} documentUrl={doc.documentUrl} index={index + 1} data-id="element-799" data-mp="21fytha1p44t" data-mpi={index} />)}
          </div>
        </div>

        <div className="mt-12 bg-au-green-light rounded-lg p-8" data-id="element-800" data-mp="3r4ota1duzv7o">
          <h3 className="text-2xl font-bold text-charcoal mb-4" data-id="element-801" data-mp="8yaey1bohj8r">Need Help?</h3>
          <p className="text-gray-700 mb-6" data-id="element-802" data-mp="3wl1kf0zgthi">
            If you have questions about AU procurement procedures or need
            assistance with the documentation, our procurement team is here to
            help.
          </p>
          <div className="flex flex-wrap gap-4" data-id="element-803" data-mp="dvk37dnbzov0">
            <a href="mailto:procurement@aucommission.org" className="text-au-green font-medium hover:underline" data-id="element-804" data-mp="rnqheu6xblrt">
              procurement@aucommission.org
            </a>
            <span className="text-gray-400" data-id="element-805" data-mp="11mg20uq7fkbr">|</span>
            <span className="text-gray-700" data-id="element-806" data-mp="11j0k7k55bx6n">+233 50 753 7362</span>
          </div>
        </div>
      </div>
    </div>;
}